module.exports = __webpack_public_path__ + "static/logomark-exclusion-14890966f6d7f07483697e643e5fa852.png";